const dev = {
	API_ENDPOINT_URL: 'http://127.0.0.1:8000/api'
};

const prod = {
	API_ENDPOINT_URL: '/api'
};

const test = {
	API_ENDPOINT_URL: 'http://127.0.0.1:8000/api'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

// REACT_APP_API_URL (en .env) tiene prioridad sobre los valores de arriba.
// CRA la incrusta al compilar: si cambia, hay que volver a correr el build.
const apiUrl = process.env.REACT_APP_API_URL;

export const env = apiUrl
	? { ...getEnv(), API_ENDPOINT_URL: apiUrl.replace(/\/+$/, '') }
	: getEnv()
